import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../../../../api";
import { AxiosError } from "axios";
import { AttendanceLocalDepartmentGuicheService } from "../../../../../../../@types/attendance-local-department-guiche-service";

export type AttendanceLocalDepartmentGuicheServiceComplementCreateData = Pick<
    AttendanceLocalDepartmentGuicheService,
    | "guiche"
> & {
    servico: number;
}

export function useAttendanceLocalDepartmentGuicheServiceComplementCreate() {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["attendance-local", "department", "guiche", "service-complement", "create"],
        mutationFn: async (data: AttendanceLocalDepartmentGuicheServiceComplementCreateData) => {
            const response = await apisiseci.post<AttendanceLocalDepartmentGuicheService>(
                '/cms/guiche_servico_complementar/', data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async () => {
            toast.success("Serviço complementar do guichê criado com sucesso!");

            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: ["attendance-local", "department", "guiche", "service-complement", "list"],
                }),
                queryClient.invalidateQueries({
                    queryKey: ['internal-service', 'list'],
                })
            ]);
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(
                error?.response?.data?.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
